// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1SQn0","col":"styles_col__3Jfo1"};